import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import moment from 'moment'
import globals from './globals'
import Popper from 'popper.js'
import VeeValidate from 'vee-validate'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue-apexcharts'
import Skeleton from 'vue-loading-skeleton';
import JwPagination from 'jw-vue-pagination';
import authHeader from '@/services/Auth-header.js';
import VueMaterial from 'vue-material'
import BootstrapVue from 'bootstrap-vue'
import LeafletMap from '@/components/map/LeafletMap.vue'
import LeafletMarker from '@/components/map/LeafletMarker.vue'
import LeafletInfoWindow from '@/components/map/LeafletInfoWindow.vue'
import LeafletAutocomplete from '@/components/map/LeafletAutocomplete.vue'
import { storageUrl } from '@/config'

moment.locale('id');

Vue.component('jw-pagination', JwPagination);
Vue.component('GmapMap', LeafletMap)
Vue.component('GmapMarker', LeafletMarker)
Vue.component('GmapInfoWindow', LeafletInfoWindow)
Vue.component('GmapAutocomplete', LeafletAutocomplete)
Vue.prototype.$storageUrl = storageUrl
Vue.prototype.$storageAsset = function (path, fallback = '/asset/img/avatar/1.png') {
  if (typeof path !== 'string') return fallback

  const normalizedPath = path.trim()
  if (!normalizedPath || normalizedPath === 'null' || normalizedPath === 'undefined') {
    return fallback
  }

  if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath

  return storageUrl + normalizedPath.replace(/^\/+/, '')
}
Vue.use(VueApexCharts)

import Echo from "laravel-echo"

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '8e448718b83556613d7f',
  cluster: 'ap1',
  encrypted: true,
  wsPort: 6001,
  disableStats: true,
  authEndpoint: 'https://api.sipamer.4visionmedia.net/broadcasting/auth',
  auth: {
    headers: {
      'Authorization': authHeader(),
    }
  }
});

//TOAST
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

// VUE PARTICLE
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
Vue.use(Skeleton)
import vueKanban from 'vue-kanban'
Vue.use(vueKanban)
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.config.productionTip = false
Vue.use(VeeValidate);
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.prototype.moment = moment
Vue.component('apexchart', VueApexCharts)
Vue.use(BootstrapVue);

// Import Bootstrap an BootstrapVue CSS files (order is important)
Vue.use(VueMaterial)

// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
